import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { useAppSettings } from '../../contexts/AppSettingsContext';

interface PageTransitionProps {
	children: ReactNode;
}

const variants = {
	initial: { opacity: 0, y: 8 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: -4 },
};

export default function PageTransition({ children }: PageTransitionProps) {
	const { shouldAnimate, durationMultiplier } = useAppSettings();

	if (!shouldAnimate) return <>{children}</>;

	return (
		<motion.div
			variants={variants}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={{ duration: 0.25 * durationMultiplier, ease: [0.25, 0.46, 0.45, 0.94] }}
		>
			{children}
		</motion.div>
	);
}
